import React from "react";
import { RouterProvider } from "react-router";
import { createBrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { initializeSentry } from "./utils/sentry";
import { routes } from "./routes";

import { Fallback } from "@/components/fallback";

// Initialize Sentry
initializeSentry();

const queryClient = new QueryClient();

const router = createBrowserRouter(routes, {
  future: {
    v7_relativeSplatPath: false,
    // v7_startTransition: false,
  },
});

function App() {
  return (
    <React.Suspense fallback={<Fallback />}>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools />
        <RouterProvider router={router} />
      </QueryClientProvider>
    </React.Suspense>
  );
}

export default App;
